import breadcrumbs from './Company_profile_breadcrumbs';
import info from './Company_profile_info';
import modals from './Company_profile_modals';
import statuses from './Company_control_admin_statuses';
import api from '../../api/index';
import router from '../../router';
import i18n from '../../i18n';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    info,
    modals,
    statuses,
  },
  state: {
    other_company: {
      countries                    : [],
      cities                       : [],
      regions                      : [],
      statuses                     : [],
      types                        : [],
      groups                       : [],
      available_annual_certificates: [],
    },
  },
  getters: {
    other_company                : ({other_company}) => other_company,
    other_active_country         : ({other_company}) => other_company.countries.find((x) => x.selected),
    other_active_city            : ({other_company}) => other_company.cities.find((x) => x.selected),
    other_active_region          : ({other_company}) => other_company.regions.find((x) => x.selected),
    other_active_type            : ({other_company}) => other_company.types.find((x) => x.selected),
    other_active_status          : ({other_company}) => other_company.statuses[0],
    other_active_group           : ({other_company}) => other_company.groups.find((x) => x.selected),
    available_annual_certificates: ({other_company: {available_annual_certificates}}) => {
      return available_annual_certificates.map(({issue_year, url, id}) => {
        return {
          'id'  : id,
          'name': i18n.t('Сертификат за {year} год', {
            'year': issue_year,
          }),
          'url': url,
        };
      });
    },
  },
  mutations: {
    SET_OTHER_COMPANY(state, value) {
      if (Array.isArray(value)) {
        state.other_company = {};
      } else {
        state.other_company = value;
      }
    },
  },
  actions: {
    async get_other_company({commit}, id) {
      try {
        let other_company = await api.company.get_company_by_id(id);

        console.log('here:', other_company);

        commit('SET_OTHER_COMPANY', other_company.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
